import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=045e895a&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('045e895a')) {
      api.createRecord('045e895a', component.options)
    } else {
      api.reload('045e895a', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=045e895a&", function () {
      api.rerender('045e895a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HMtB83I6YR7n/JS/comp/IncreaseNumber.vue"
export default component.exports